// ===== client/src/context/teams/teamReducer.js =====
import {
  GET_TEAMS,
  GET_TEAM,
  ADD_TEAM,
  UPDATE_TEAM,
  DELETE_TEAM,
  TEAM_ERROR,
  CLEAR_TEAMS,
  SET_CURRENT_TEAM,
  CLEAR_CURRENT_TEAM,
  SET_ACTIVE_TEAM,
  CLEAR_ACTIVE_TEAM
} from '../types';

const teamReducer = (state, action) => {
  switch (action.type) {
    case GET_TEAMS:
      return {
        ...state,
        teams: action.payload,
        loading: false
      };

    case GET_TEAM:
      return {
        ...state,
        currentTeam: action.payload,
        loading: false
      };

    case ADD_TEAM:
      return {
        ...state,
        teams: [action.payload, ...state.teams],
        loading: false
      };

    case UPDATE_TEAM:
      return {
        ...state,
        teams: state.teams.map(team =>
          team._id === action.payload._id ? action.payload : team
        ),
        currentTeam: action.payload,
        loading: false
      };

    case DELETE_TEAM:
      return {
        ...state,
        teams: state.teams.filter(team => team._id !== action.payload),
        // If the activeTeam was deleted, clear it too
        activeTeam:
          state.activeTeam && state.activeTeam._id === action.payload
            ? null
            : state.activeTeam,
        loading: false
      };

    case SET_CURRENT_TEAM:
      return {
        ...state,
        currentTeam: action.payload
      };

    case CLEAR_CURRENT_TEAM:
      return {
        ...state,
        currentTeam: null
      };

    case SET_ACTIVE_TEAM:
      localStorage.setItem('activeTeam', JSON.stringify(action.payload));
      return {
        ...state,
        activeTeam: action.payload
      };

    case CLEAR_ACTIVE_TEAM:
      localStorage.removeItem('activeTeam');
      return {
        ...state,
        activeTeam: null
      };

    case CLEAR_TEAMS:
      return {
        ...state,
        teams: [],
        currentTeam: null,
        activeTeam: null,
        error: null,
        loading: false
      };

    case TEAM_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    default:
      return state;
  }
};

export default teamReducer;